/* eslint-disable react-hooks/exhaustive-deps */
import LeftArrow from 'icons/black.svg';
import SearchIcon from 'icons/search.svg';
import { debounce } from 'rambdax';
import { ReactNode, useEffect, useRef, useState } from 'react';
import { Search } from 'react-vant';
import { SearchProps } from 'react-vant/es/search';
import { cls } from 'reactutils';

export default function SearchSelect({
  placeholder = '请选择',
  slot,
  value = {},
  onClickSearchIcon,
  query,
  title,
  change,
  showRecent,
  getRecent,
  saveRecent,
  name = 'name',
  ...props
}: SearchProps & {
  slot?: ReactNode;
  value?: any;
  query: any;
  title?: string;
  change: Function;
  showRecent?: boolean;
  getRecent?: any;
  saveRecent?: any;
  name?: string;
  onClickSearchIcon?: () => void;
}) {
  const [opened, setOpened] = useState(false);
  const [list, setList] = useState([]);
  const [recentList, setRecentList] = useState([]);
  const params = useRef({ pageNo: 1, pageSize: 20, name: '' });
  const [searchName, setSearchName] = useState('');
  const loading = useRef(false);
  const searchList = useRef<any>();
  const totalPage = useRef(0);
  const clear = () => {};

  const onChange = (e) => {
    setSearchName(e);
    debounce(() => {
      onSearch(e);
    }, 300);
  };

  const onSearch = (e) => {
    params.current.name = e;
    params.current.pageNo = 1;
    fetchData(true);
  };

  const fetchData = async (init?: boolean) => {
    if (!loading.current) {
      loading.current = true;
      const res = await query(params.current);
      totalPage.current = res.data?.totalPage;
      const arr = init ? res.data?.datas : [...list, ...res.data?.datas];
      setList(arr);
      setTimeout(() => {
        loading.current = false;
      }, 100);
    }
  };

  const scrollFn = (e) => {
    if (e.target.scrollTop + e.target.offsetHeight >= e.target.scrollHeight - 100) {
      if (params.current.pageNo < totalPage.current && !loading.current) {
        params.current.pageNo++;
        fetchData();
      }
    }
  };

  const choose = (e) => {
    change(e);
    setOpened(false);
    if (saveRecent) {
      saveRecent({ [name]: e[name], sysNo: e.sysNo });
    }
  };

  useEffect(() => {
    if (opened) {
      searchList.current.addEventListener('scroll', scrollFn);
      if (showRecent) {
        getRecent?.().then((v) => {
          setRecentList(v.data);
        });
      }
    }
    return () => {
      if (searchList.current) {
        searchList.current.removeEventListener('scroll', scrollFn);
      }
    };
  }, [opened, list]);

  useEffect(() => {
    fetchData();
  }, []);

  const searchRight = async () => {
    if (onClickSearchIcon) {
      onClickSearchIcon();
    } else {
      onSearch(searchName);
    }
  };

  return (
    <>
      <div className="itemWrap">
        <div className="itemTitle">{title}</div>
        <div className={cls('text-panel', opened && 'open-pop')} onClick={() => setOpened(!opened)}>
          <div className={cls('current-box')}>{value?.[name] ?? placeholder}&nbsp;</div>
          <LeftArrow />
        </div>
        {opened && (
          <div className="custom-search">
            <Search
              value={searchName}
              leftIcon={null}
              rightIcon={
                <span className="icon-box" onClick={searchRight}>
                  <SearchIcon />
                </span>
              }
              onChange={onChange}
              onSearch={onSearch}
              onClear={clear}
              placeholder={placeholder}
              {...props}
            />
            {showRecent && (
              <div className="recent-box">
                <div>
                  <div className="recent-title">最近访问：</div>
                  {recentList?.map((v, i) => (
                    <div key={i} className="list-item" onClick={() => choose(v)}>
                      {v[name]}
                    </div>
                  ))}
                </div>
                <div className="recent-title">全部({list?.length ?? 0})：</div>
              </div>
            )}
            <div className="search-list" ref={searchList}>
              {list?.length > 0 ? (
                list.map((v, i) => (
                  <div
                    key={i}
                    className={cls('list-item', value?.sysNo === v.sysNo && 'active')}
                    onClick={() => choose(v)}
                  >
                    {v[name]}
                  </div>
                ))
              ) : (
                <div className="nodata">无数据</div>
              )}
            </div>
          </div>
        )}
      </div>
      <style jsx>{`
        .custom-search {
          background-color: #fff;
          border: 1px solid #f1f1f1;
          border-radius: 0 0 3px 3px;
        }
        .text-panel {
          background: #f2f2f2;
          border-radius: 3px;
          display: flex;
          justify-content: space-between;
          padding: 13px 16px;
        }
        .itemWrap {
          padding: 10px 20px 17px 20px;
          border-bottom: 2px solid #f9f9f9;
        }
        .itemWrap:last-child {
          border-bottom: none;
        }

        .itemTitle {
          font-size: 15px;
          color: #262626;
          line-height: 13px;
          font-weight: bold;
          margin-bottom: 17px;
        }
        .back-box {
          display: flex;
          align-items: center;
          width: 20px;
          justify-content: flex-end;
        }
        .back-box :global(svg) {
          height: 14px;
        }
        .icon-box :global(svg) {
          transform: translateY(2px);
        }
        .custom-search :global(.rv-search__content) {
          align-items: center;
          height: 40px;
          background: #f2f2f2;
          border-radius: 3px;
        }
        .custom-search :global(.rv-search) {
          flex: 1;
        }
        .text-panel :global(svg) {
          transform: translate(2px, 4px) rotate(-90deg);
        }
        .open-pop :global(svg) {
          transform: translate(2px, 4px) rotate(90deg);
        }
        .search-list {
          max-height: 200px;
          overflow: hidden;
          overflow-y: auto;
        }
        .list-item {
          height: 40px;
          line-height: 40px;
          padding: 0 13px;
          font-size: 14px;
          color: #333333;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
        }
        .active {
          color: var(--primaryColor);
        }
        .nodata {
          font-size: 14px;
          color: #333333;
          text-align: center;
          padding-top: 10px;
          padding-bottom: 20px;
        }
        .recent-box {
        }
        .recent-title {
          font-size: 14px;
          color: #999999;
          padding: 0 16px;
        }
      `}</style>
    </>
  );
}
